import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const menuAPI = {
  getMenu: () => api.get('/menu'),
  getAllMenuItems: () => api.get('/menu/all'),
  createMenuItem: (data) => api.post('/menu', data),
  updateMenuItem: (id, data) => api.put(`/menu/${id}`, data),
  deleteMenuItem: (id) => api.delete(`/menu/${id}`),
  reorderMenuItems: (items) => api.put('/menu/reorder', { items }),
  getCategories: () => api.get('/categories'),
  getAllCategories: () => api.get('/categories/all'),
  createCategory: (name) => api.post('/categories', { name }),
  updateCategory: (id, name) => api.put(`/categories/${id}`, { name }),
  deleteCategory: (id) => api.delete(`/categories/${id}`),
  reorderCategories: (items) => api.put('/categories/reorder', { items }),
  createSubcategory: (categoryId, name) => api.post(`/categories/${categoryId}/subcategories`, { name }),
  updateSubcategory: (categoryId, subcategoryId, name) => api.put(`/categories/${categoryId}/subcategories/${subcategoryId}`, { name }),
  deleteSubcategory: (categoryId, subcategoryId) => api.delete(`/categories/${categoryId}/subcategories/${subcategoryId}`),
  reorderSubcategories: (categoryId, items) => api.put(`/categories/${categoryId}/subcategories/reorder`, { items }),
};

export const deliveryAPI = {
  // Admin endpoints
  getPostcodes: () => api.get('/admin/delivery-postcodes'),
  createPostcode: (data) => api.post('/admin/delivery-postcodes', data),
  updatePostcode: (id, data) => api.put(`/admin/delivery-postcodes/${id}`, data),
  deletePostcode: (id) => api.delete(`/admin/delivery-postcodes/${id}`),
  // Client endpoint
  validatePostcode: (postcode) => api.post('/delivery/validate-postcode', { postcode }),
};

export const orderAPI = {
  createOrder: (data) => api.post('/orders', data),
  getUserOrders: () => api.get('/orders'),
  getAllOrders: () => api.get('/orders/all'),
  getOrder: (id) => api.get(`/orders/${id}`),
  getOrderBySession: (sessionId) => api.get(`/orders/by-session/${sessionId}`),
  updateOrderStatus: (id, status) => api.put(`/orders/${id}/status`, { order_status: status }),
  deleteOrder: (id) => api.delete(`/orders/${id}`),
};

export const paymentAPI = {
  createCheckoutSession: (data) => api.post('/payment/checkout', data),
  getPaymentStatus: (sessionId) => api.get(`/payment/status/${sessionId}`),
};

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  signup: (data) => api.post('/auth/signup', data),
  getMe: () => api.get('/auth/me'),
};

export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getNewOrdersCount: () => api.get('/admin/orders/new'),
};

export const bundleAPI = {
  // Modifier groups (reusable across products & bundle options)
  listModifierGroups: (includeInactive = false) =>
    api.get('/modifier-groups', { params: { include_inactive: includeInactive } }),
  createModifierGroup: (data) => api.post('/admin/modifier-groups', data),
  updateModifierGroup: (id, data) => api.put(`/admin/modifier-groups/${id}`, data),
  deleteModifierGroup: (id) => api.delete(`/admin/modifier-groups/${id}`),
  modifierGroupUsage: (id) => api.get(`/admin/modifier-groups/${id}/usage`),
};
